import type { ReviewStatus } from '../../../constants';
import { ProductStatistic, Review } from '../../../model';

export type GetProductReviewsRequest = {
  productId: number;
  status?: ReviewStatus;
  locale?: string;
};

export type GetProductReviewsResponse = Review[];

export type GetAIProductReviewsRequest = GetProductReviewsRequest;
export type GetAIProductReviewsResponse = Review[];

export type GetCuratedReviewsRequest = {
  locale?: string;
};

export type GetCuratedReviewsResponse = Review[];

export type ReviewStatisticsRequest = {
  productIds: string;
};

export type ReviewStatisticsResponse = {
  statistics: ProductStatistic[];
};

export type CreateReviewRequest = {
  reviewId?: number;
  name: string;
  email?: string;
  rating: number;
  body: string;
  productId: number;
  title?: string;
  files?: File[];
  skinType: string[];
  skinConcern: string[];
};

export type CreateReviewResponse = Review;
